module.exports = __webpack_public_path__ + "img/logo_uefs2.cee67248.png";